/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from 'antd/componetns/typogrpahy/Title.tsx
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import warning from 'antd/es/_util/warning';
import Base from 'antd/es/typography/Base';
import { tupleNum } from 'antd/es/_util/type';
import { ConfigContext } from '../config-provider';
import AntdConfigProvider from 'antd/es/config-provider';
const TITLE_ELE_LIST = tupleNum(1, 2, 3, 4, 5, 6);
const Title = (props) => {
    const { level = 1, prefixCls: customizePrefixCls, ...restProps } = props;
    const { getPrefixCls, ...restContext } = React.useContext(ConfigContext);
    let component;
    if (TITLE_ELE_LIST.indexOf(level) !== -1) {
        component = `h${level}`;
    }
    else {
        if (process.env.NODE_ENV !== 'production')
            warning(false, 'Typography.Title', 'Title only accept `1 | 2 | 3 | 4 | 5 | 6` as `level` value. And `5` need 4.6.0+ version.');
        component = 'h1';
    }
    return (React.createElement(AntdConfigProvider, { ...restContext, prefixCls: getPrefixCls('', customizePrefixCls) },
        React.createElement(Base, { ...restProps, component: component })));
};
export default Title;
